import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeInfractor, getTiposDeInfractores, patchTipoDeInfractor, postTipoDeInfractor,
} from 'api/catalogos/tiposDeInfractor';

// eslint-disable-next-line react/prop-types
const TiposDeInfractores = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Infractor"
    permission={permission}
    get={getTiposDeInfractores}
    post={postTipoDeInfractor}
    patch={patchTipoDeInfractor}
    delete={deleteTipoDeInfractor}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
  />
);

export default TiposDeInfractores;
